import { FunctionComponent, useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../common/error/ErrorMessage';
import { ConfigContext } from '../configuration/ConfigContext';
import PaperLayout from '../layout/PaperLayout';
import { usePropertyAssociationContext } from '../propertyAssociation/PropertyAssociationContext';
import { useNavigationPaths } from '../propertyAssociation/useNavigationPaths';
import { ToastContext } from '../toaster/ToastContext';
import { ToastMessageType } from '../toaster/models/ToastMessageType';
import PinboardMessageForm from './components/PinboardMessageForm';
import { PinboardMessageFormModel, mapFormToUpdateRequest, mapResponseToForm } from './models/PinboardMessageFormModel';
import { updatePinboardMessage, usePinboardMessage } from './pinboardMessageService';

const EditPinboardMessage: FunctionComponent = () => {
    const navigate = useNavigate();
    const { id } = useParams<any>();
    const { apiBaseUrl } = useContext(ConfigContext);
    const { currentPropertyAssociationId, isRBHyr } = usePropertyAssociationContext();
    const { addToast } = useContext(ToastContext);
    const paths = useNavigationPaths();
    const { pinboardMessage, error } = usePinboardMessage(id);
    const [values, setValues] = useState<PinboardMessageFormModel | undefined>();

    const handleValidSubmit = useCallback(
        (messageForm: PinboardMessageFormModel) => {
            updatePinboardMessage(
                apiBaseUrl,
                currentPropertyAssociationId,
                id!,
                mapFormToUpdateRequest(messageForm),
                () => {
                    addToast('Meddelandet har sparats.');
                    navigate(`${paths.adverts}/information/${id}`);
                },
                () => {
                    addToast('Kunde ej uppdatera meddelandet.', undefined, ToastMessageType.Error);
                },
            );
        },
        [id],
    );

    useEffect(() => {
        if (pinboardMessage) {
            setValues(mapResponseToForm(pinboardMessage));
        }
    }, [pinboardMessage]);

    if (error) {
        return <ErrorMessage message="Kunde inte ladda meddelandet." />;
    }

    if (!values) {
        return null;
    }

    return (
        <PaperLayout
            heading="Hantera meddelande"
            tightenUp={true}
            mainClass="px-0 pt-3"
            preamble={
                <>
                    <strong>Information till boende</strong>
                    <p>Publicerade meddelanden ses av fastighetens boende på anslagstavlan i Mitt Boende-appen. {isRBHyr ? 'Hyresvärden' : 'Styrelsen'} står som avsändare.</p>
                </>
            }
        >
            <PinboardMessageForm onCancel={() => navigate(`${paths.adverts}/information/${id}`)} messageForm={values} onValidSubmit={handleValidSubmit} />
        </PaperLayout>
    );
};

export default EditPinboardMessage;
